import React, { ComponentProps, FunctionComponent } from "react";

const CogsIcons = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 12 12",
        fill: "currentColor",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.15583 0.304215C7.13008 0.128812 6.97934 0 6.80206 0H5.19793C5.02065 0 4.8699 0.128812 4.84415 0.304215C4.79446 0.642678 4.71552 1.20704 4.66499 1.70133C4.40023 1.78347 4.14595 1.88938 3.90462 2.01659C3.51932 1.70275 3.0643 1.3594 2.78977 1.15517C2.64754 1.04935 2.44986 1.06485 2.3245 1.19021L1.19021 2.3245C1.06486 2.44986 1.04935 2.64754 1.15517 2.78977C1.35941 3.0643 1.70275 3.51932 2.01659 3.90462C1.88938 4.14595 1.78346 4.40024 1.70133 4.66499C1.20704 4.71553 0.642677 4.79447 0.304215 4.84416C0.128812 4.86991 0 5.02065 0 5.19794V6.80206C0 6.97935 0.128812 7.13009 0.304215 7.15584C0.642678 7.20553 1.20704 7.28447 1.70133 7.33501C1.78346 7.59976 1.88938 7.85405 2.01659 8.09537C1.70275 8.48067 1.3594 8.93569 1.15516 9.21022C1.04934 9.35246 1.06485 9.55013 1.19021 9.67549L2.3245 10.8098C2.44986 10.9351 2.64753 10.9506 2.78977 10.8448C3.06429 10.6406 3.51931 10.2972 3.90461 9.98341C4.14594 10.1106 4.40023 10.2165 4.66499 10.2987C4.71552 10.793 4.79446 11.3573 4.84415 11.6958C4.8699 11.8712 5.02065 12 5.19793 12H6.80206C6.97934 12 7.13008 11.8712 7.15583 11.6958C7.20552 11.3573 7.28447 10.793 7.335 10.2987C7.59976 10.2165 7.85405 10.1106 8.09538 9.98341C8.48068 10.2972 8.9357 10.6406 9.21022 10.8448C9.35246 10.9507 9.55014 10.9351 9.6755 10.8098L10.8098 9.6755C10.9351 9.55014 10.9507 9.35246 10.8448 9.21022C10.6406 8.9357 10.2972 8.48068 9.98341 8.09538C10.1106 7.85405 10.2165 7.59977 10.2987 7.33501C10.793 7.28447 11.3573 7.20553 11.6958 7.15584C11.8712 7.13009 12 6.97935 12 6.80207V5.19794C12 5.02065 11.8712 4.86991 11.6958 4.84416C11.3573 4.79447 10.793 4.71553 10.2987 4.66499C10.2165 4.40023 10.1106 4.14595 9.98341 3.90461C10.2972 3.51931 10.6406 3.06429 10.8448 2.78977C10.9506 2.64753 10.9351 2.44986 10.8098 2.3245L9.67549 1.19021C9.55013 1.06485 9.35246 1.04934 9.21022 1.15516C8.9357 1.3594 8.48067 1.70275 8.09537 2.01659C7.85404 1.88938 7.59976 1.78346 7.335 1.70133C7.28447 1.20704 7.20552 0.642677 7.15583 0.304215ZM6 8.04C7.12666 8.04 8.04 7.12666 8.04 6C8.04 4.87334 7.12666 3.96 6 3.96C4.87334 3.96 3.96 4.87334 3.96 6C3.96 7.12666 4.87334 8.04 6 8.04Z",
    })
  );
};

const ForwardRef = React.forwardRef(CogsIcons) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
